module.exports = __webpack_public_path__ + "static/media/08.6dfc8d2e.png";